export default __webpack_public_path__ + "static/l2-content-img-1-fca56e3dab73ee4e82b95d7ef9721e3f.png";